import type { ReactNode } from 'react';

import { getLocale } from '../../i18n';
import { Badge } from '../../ui/badge';
import { Hint } from '../hint';
import { share } from './format';
import { mt } from './messages';

export function EstimateLabel(props: {
  methodVersion: string;
  confidence: number | null;
}): ReactNode {
  return (
    <span className="inline-flex items-center gap-1">
      <Badge variant="outline" className="border-dashed">
        {mt('estimate.label', { version: props.methodVersion })}
      </Badge>
      {props.confidence !== null && (
        <span data-numeric className="text-caption text-muted-foreground">
          {mt('estimate.confidence', { confidence: share(props.confidence, getLocale()) })}
        </span>
      )}
      <Hint label={mt('estimate.about')}>{mt('estimate.explain')}</Hint>
    </span>
  );
}
